module.exports = __webpack_public_path__ + "static/img/preparing.e4897c3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/preparing.png
// module id = WD7s
// module chunks = 1